




















import { Component, Vue } from "vue-property-decorator";
import { wxChatShare } from "@/common/wechat.ts";
import { Tab, Tabs, Loading, List } from "vant";
import request from "@/api/index";
@Component({})
export default class Nasc extends Vue {
  columnImg: any = []; // banner

  created() {
    document.title = "市场主体集群注册平台";

    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0
      });
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "市场主体集群注册平台",
        isShowMoreBtn: "1"
      });
      ZWY_CLOUD.shareConfig({
        id: "",
        shareTitle: "市场主体集群注册平台",
        shareDescription: "南岸区集群注册",
        sourceType: "1",
        shareImgUrl: "https://imagecdn.cqliving.com/images/icon/4.png",
        shareUrl: window.location.href,
        shareUrlQQ: window.location.href,
        shareUrlQzone: window.location.href,
        shareUrlWx: window.location.href,
        shareUrlWxMoments: window.location.href,
        shareUrlWeibo: window.location.href
      });
    } else {
      wxChatShare(
        "市场主体集群注册平台",
        "南岸区集群注册",
        window.location.href,
        "https://imagecdn.cqliving.com/images/icon/4.png"
      );
    }
  }

  toLink(link: string) {
    if (link == "1") {
      // 托管机构登记备案
      window.open(
        "http://219.153.117.133:8088/mobilemode/mobile/view.html?appid=1&mTokenFrom=anonymous&mToken=F36F5E4A746590AB827B555F8EC40CEF"
      );
    } else if (link == "2") {
      // 市场主体集群注册备案
      window.open(
        "http://219.153.117.133:8088/mobilemode/mobile/view.html?appid=2&mTokenFrom=anonymous&mToken=2D7C21ED8BA3DDF91D50FB9446C0B342"
      );
    } else if (link == "3") {
      // 个体工商户集群注册备案
      window.open(
        "http://219.153.117.133:8088/mobilemode/mobile/view.html?appHomepageId=22&mTokenFrom=anonymous&mToken=AFE5337AE1E1DBDC52880335BE389462"
      );
    } else if (link == "4") {
      // 市场主体集群注册补录
      window.open(
        "http://219.153.117.133:8088/mobilemode/mobile/view.html?appid=3&mTokenFrom=anonymous&mToken=3F762EE751F86A734C07D391F2096845"
      );
    } else if (link == "5") {
      //个体工商户集群注册补录
      window.open(
        "http://219.153.117.133:8088/mobilemode/mobile/view.html?appHomepageId=23&mTokenFrom=anonymous&mToken=6A9A509F1B44D3B3098C5C38FE766313"
      );
    }
  }
}
